var map = {
	"./gallery_00.jpg": 2061,
	"./gallery_01.jpg": 2062,
	"./gallery_02.jpg": 2063,
	"./gallery_03.jpg": 2064,
	"./gallery_04.jpg": 2065
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2060;